// ./app/layout.tsx
'use client';

// Imports
// ========================================================
import Head from 'next/head';
import { HighlightInit } from '@highlight-run/next/highlight-init';
import { HIGHLIGHT_PROJECT_ID } from '#/config/env';
import '#/services/logrocket';
import ToastContainer from '~/Toast/ToastContainer';
import RootProvider from './providers';

// CSS Imports
// ========================================================
import 'reactflow/dist/base.css';
import '@rainbow-me/rainbowkit/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import '#/styles/globals.css';

// Layout
// ========================================================
export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <HighlightInit
        projectId={HIGHLIGHT_PROJECT_ID}
        tracingOrigins
        networkRecording={{
          enabled: true,
          recordHeadersAndBody: true,
          urlBlocklist: [],
        }}
      />
      <html>
        <Head>
          <meta
            property="og:logo"
            content="https://alpha.simpfi.ai/simpfinogrid.png"
          />
        </Head>
        <body className="bg-gray-1100 bg-[url('/grid.svg')] min-h-[100vh] overflow-y:hidden">
          <RootProvider>
            {children}
            <ToastContainer />
          </RootProvider>
        </body>
      </html>
    </>
  );
}
